import React from "react";
import { RouteConfig } from "../../../../../config/router/router.config";
import { IMaintainer } from "../../../../../model/user/maintainer/maintainer.model";

export type MaintainerEditRouteParam = {
  maintainer: IMaintainer;
};

export const maintainerEditRoute: RouteConfig = {
  name: "Edit Maintainer",
  Component: React.lazy(() => import("./MaintainerEdit.view")),
  path: "/user/maintainer/edit/:id",
  isPrivate: true,
  roleLevelMax: 0,
};
